import styled from 'styled-components';
import { Text as _Text, Buttons, FlexContainer } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';
import { pxToRem } from 'Styles/utils/utils';

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    display: grid;
    grid-template-columns: 3fr;
    grid-column-gap: ${pxToRem(30)};
    padding: ${pxToRem(30)};
    height: 100%;
  }
`;

export const Text = styled(_Text)`
  width: 400px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;

export const Span = styled.span`
  font-weight: bold;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const ReadOnlyView = styled.div`
  position: absolute;
  width: 100%;
  height: 75%;
  bottom: 0;
  z-index: ${({ theme: { system } }) => system.zIndex.fds_sys_zindex_highlighted};
`;

export const HelpButton = styled(Buttons.Contextual)`
  margin-left: ${({ theme: { reference } }) => reference.dimension_08};
  display: inline-block;
  vertical-align: middle;
`;

export const Container = styled(FlexContainer)`
  width: 450px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
